import axios from 'axios'
import { getToken, clearAuth } from './auth'

const api = axios.create({ baseURL: process.env.VUE_APP_API_URL })

api.interceptors.request.use(config => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

api.interceptors.response.use(
  res => res,
  error => {
    if (error.response?.status === 401 && error.config.url !== '/auth/login') {
      clearAuth()
      if (!window.location.pathname.startsWith('/admin/login')) {
        window.location.href = '/admin/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api

export const publicApi = axios.create({ baseURL: process.env.VUE_APP_API_URL })
